import { render } from "./KeyboardF10.vue?vue&type=template&id=7b0d51d2"
import script from "./KeyboardF10.vue?vue&type=script&lang=js"
export * from "./KeyboardF10.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/KeyboardF10.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b0d51d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b0d51d2', __exports__)) {
    api.reload('7b0d51d2', __exports__)
  }
  
  module.hot.accept("./KeyboardF10.vue?vue&type=template&id=7b0d51d2", () => {
    api.rerender('7b0d51d2', render)
  })

}


export default __exports__